// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__tv1jq","btn__close":"Modal_btn__close__YK4di"};